import { forwardRef } from "react";
import Stack from '@mui/material/Stack';
import Snackbar from '@mui/material/Snackbar';
import MuiAlert from '@mui/material/Alert';
import { useTranslation } from "react-i18next";

const Alert = forwardRef(function Alert(props, ref) {
    return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});

export const ModalConfirm = ({ open, setOpen }) => {

    const { t } = useTranslation('global');
    const handleClose = (event, reason) => {
        if (reason === 'clickaway') {
          return;
        }
        setOpen(false);
      };

    return (
        <Stack spacing={2} sx={{ width: '100%' }}>
            <Snackbar
                open={open}
                autoHideDuration={6000}
                anchorOrigin={{
                    vertical: "bottom",
                    horizontal: "center"
                }}
                onClose={handleClose}
            >
                <Alert severity="success" sx={{ width: '100%' }} onClose={handleClose}>
                    {t("createPassword.onConfirm")}
                </Alert>
            </Snackbar>
        </Stack>
    )
}
